export const { REACT_APP_API_URL, REACT_APP_WS_URL } = process.env
//export const REACT_APP_API_URL = "http://13.232.243.101/api"
//export const REACT_APP_API_URL = "/api/core"